import styled from 'styled-components';

export const BrokerListItemCard = styled.li`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 0;
  margin-bottom: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    border-color: #00a651;
  }
`;

export const BrokerListItemHeader = styled.div`
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  padding: 1rem 1.25rem;

  h4 {
    font-size: 0.95rem;
    font-weight: 700;
    margin: 0 0 0.25rem 0;
    letter-spacing: 0.3px;
  }

  p {
    margin: 0;
    font-size: 0.8rem;
    opacity: 0.95;
  }
`;

export const BrokerListItemContent = styled.div`
  background: #fafafa;
  padding: 1rem 1.25rem;
`;

export const BrokerListItemSection = styled.div`
  margin-bottom: 0.75rem;
`;

export const BrokerListItemLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.25rem;
`;

export const BrokerListItemValue = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  color: #333;
`;

export const BrokerListItemStatusBadge = styled.span`
  display: inline-block;
  padding: 0.3rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  background: ${(props) => {
    if (props.variant === 'new') return '#e3f2fd';
    if (props.variant === 'ko') return '#fdecea';
    return '#f5f5f5';
  }};
  color: ${(props) => {
    if (props.variant === 'new') return '#1976d2';
    if (props.variant === 'ko') return '#c62828';
    return '#616161';
  }};
  border: 1.5px solid ${(props) => {
    if (props.variant === 'new') return '#1976d2';
    if (props.variant === 'ko') return '#c62828';
    return '#616161';
  }};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

export const BrokerListItemRenewalBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.25rem 0.7rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.95);
  color: #b45309;
  border: 1.5px solid #f59e0b;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
`;

export const BrokerListItemAction = styled.span`
  display: inline-block;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  background: linear-gradient(135deg, #00a651 0%, #008a44 100%);
  color: white;
  border: none;

  &:hover {
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 166, 81, 0.3);
  }
`;

export const BrokerListItemDocumentsBadge = styled.span`
  display: inline-block;
  padding: 0.3rem 0.75rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 700;
  background: ${(props) => (props.signed ? '#e8f5e9' : '#fff3e0')};
  color: ${(props) => (props.signed ? '#2e7d32' : '#e65100')};
  border: 1.5px solid ${(props) => (props.signed ? '#2e7d32' : '#e65100')};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

export const BrokerListItemRiskGroup = styled.div`
  border-top: 1px dashed #e0e0e0;
  padding: 1rem 1.25rem 0.25rem;
  background: #f4f4f4;
`;

export const BrokerListItemRiskGroupLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-top: 0.25rem;
`;

export const BrokerListItemRiskCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-left: 3px solid #00a651;
  border-radius: 6px;
  margin-bottom: 0.75rem;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0.75rem;
  }

  ${BrokerListItemHeader} {
    padding: 0.6rem 1rem;

    h4 {
      font-size: 0.8rem;
      margin-bottom: 0.15rem;
    }

    p {
      font-size: 0.7rem;
    }
  }

  ${BrokerListItemContent} {
    padding: 0.75rem 1rem;
  }

  ${BrokerListItemSection} {
    margin-bottom: 0.5rem;
  }

  ${BrokerListItemLabel} {
    font-size: 0.65rem;
    margin-bottom: 0.15rem;
  }

  ${BrokerListItemValue} {
    font-size: 0.8rem;
  }

  ${BrokerListItemStatusBadge},
  ${BrokerListItemDocumentsBadge} {
    padding: 0.2rem 0.55rem;
    font-size: 0.65rem;
  }

  ${BrokerListItemAction} {
    padding: 0.5rem 1.25rem;
    font-size: 0.85rem;
  }
`;

export const BrokerListItemFilterCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;

  h5 {
    color: #333;
    font-weight: 600;
    margin-bottom: 1.25rem;
    font-size: 1.1rem;
    padding-bottom: 0.75rem;
    border-bottom: 2px solid #f0f0f0;
  }

  label {
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
    display: block;
  }

  input, select {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    padding: 0.65rem 0.85rem;
    font-size: 0.95rem;
    transition: all 0.3s ease;

    &:focus {
      border-color: #00a651;
      box-shadow: 0 0 0 3px rgba(0, 166, 81, 0.1);
      outline: none;
    }

    &::placeholder {
      color: #999;
    }
  }
`;
